
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ColorPanel from "./color-panel.vue";
import HueSlider from "./hue-slider.vue";
import Color from "../../utils/colorHelper";

@Component({
  components: {
    ColorPanel,
    HueSlider
  }
})
export default class PickerDropdown extends Vue {
  @Prop({ required: true }) startColor!: Color;
  @Prop({ required: true }) endColor!: Color;
  @Prop({ default: false, type: Boolean }) showAlpha!: boolean;

  visible = false;
  customStartInput = "";
  customEndInput = "";
  activeIdx = 0;

  get color() {
    return this.activeIdx === 0 ? this.startColor : this.endColor;
  }

  get tagStyle() {
    return {
      background: `linear-gradient(to right, ${this.startColor.value}, ${this.endColor.value})`
    };
  }

  get currentStartColor() {
    return this.startColor.value;
  }

  get currentEndColor() {
    return this.endColor.value;
  }

  handleStartConfirm() {
    this.startColor.fromString(this.customStartInput);
  }

  handleEndConfirm() {
    this.endColor.fromString(this.customEndInput);
  }

  @Watch("visible")
  changeVisible(val: boolean) {
    if (!val) return;
    this.$nextTick(() => {
      const { cp, hue, alpha } = this.$refs;
      cp && (cp as any).update();
      hue && (hue as any).update();
      alpha && (alpha as any).update();
    });
  }

  @Watch("currentStartColor", { immediate: true })
  changeStartColor(val: string) {
    this.customStartInput = val;
  }

  @Watch("currentEndColor", { immediate: true })
  changeEndColor(val: string) {
    this.customEndInput = val;
  }
}
